import './applied_post_type_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedPostFacebookTypeFilterView extends Monitoring.Views.SocialContents.Filters.AppliedPostTypeView
  name: 'post_facebook_type'

  removeFilter: (value) ->
    @searchQuery.removePostFacebookType(value)
